/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ScrollLink } from 'react-scroll';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { scrollerSettings } from '../../../../settings';
import { CardContext } from '../CardContext';

/**
 * Empty card content that presents a 'No data entered message'.
 * If the sectionName is available and isSummary prop is false, then a 'Go to section' link is displayed.
 *
 * @returns {JSX.Element}
 */
export default function EmptyData() {
  const { classes, isSummary, sectionName } = useContext(CardContext);
  const { t } = useTranslation();

  return (
    <Grid item container spacing={2} className={classes.noData}>
      <Grid item xs={12}>
        <Typography className={classes.noDataLabel} variant="subtitle2" color="textSecondary" display="inline">
          {t('messages.no.data.entered')}
        </Typography>
      </Grid>
      {sectionName && !isSummary && (
        <Grid item xs={12}>
          <ScrollLink
            activeClass="active"
            to={sectionName}
            spy={true}
            smooth={scrollerSettings.smooth}
            offset={scrollerSettings.offset}
            delay={scrollerSettings.delay}
            duration={scrollerSettings.duration}
            className={classes.scrollLink}
          >
            {t('messages.go.section')}
          </ScrollLink>
        </Grid>
      )}
    </Grid>
  );
}
